/*
 * A patient name worth showing. The Android app can create a chat whose
 * patientName is the text "null"; the lists then fall back to the name from
 * the patient's account. The server also replaces such names when a chat is
 * created (cloudfunctions functionsV2/patientIntro.js), so this covers chats
 * created before that and the clinic lists.
 */
const PLACEHOLDERS = new Set(['null', 'undefined', 'no name', 'patient', '']);

/* `value` as a trimmed string, or null when it is missing or a placeholder. */
export const realName = (value) => {
    if (value === undefined || value === null) return null;
    const text = String(value).trim();
    return PLACEHOLDERS.has(text.toLowerCase()) ? null : text;
};

/* The name on the patient's account for this chat: the family member's when the
   chat is theirs (owner set and not the account itself), else the holder's. */
export const accountName = (patient, chat) => {
    if (!patient) return null;
    const owner = chat && chat.owner;
    if (owner && owner !== chat.patientID) {
        const member = patient.profiles && patient.profiles[owner];
        return realName(member && member.name) || realName(member && member.userName);
    }
    return realName(patient.name) || realName(patient.userName);
};

/* What a chat list shows: the chat's own name when it is a real one, else the
   account's, else "Patient". */
export const listName = (chatName, account) => realName(chatName) || realName(account) || 'Patient';
